/* eslint-disable max-len */

import { get, post } from '../utils/api';

export default class HouseholdAffordableRecertDueDateService {
  getHouseholdAffordableRecertDueDates(
    organizationId: string,
    propertyId: string,
    householdId: string,
    options?: Object,
  ): any {
    return get(
      `/${organizationId}/${propertyId}/households/${householdId}/recert-due-dates`,
      options,
    );
  }

  updateHouseholdAffordableRecertDueDates(
    organizationId: string,
    propertyId: string,
    householdId: string,
    values: Object,
    options?: Object,
  ): any {
    return post(
      `/${organizationId}/${propertyId}/households/${householdId}/recert-due-dates`,
      JSON.stringify(values),
      options,
    );
  }
}
